import { Component } from '@angular/core';
import alertify from "alertifyjs";
import {Location} from "@angular/common";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {ApiServiceService} from "../../../../Services/api-service.service";
import {BsModalService} from "ngx-bootstrap/modal";
import {AuthService} from "../../../../Services/auth.service";

@Component({
  selector: 'app-audit-trails',
  templateUrl: './audit-trails.component.html',
  styleUrls: ['./audit-trails.component.css']
})
export class AuditTrailsComponent {
  isLoading: boolean;
  data: any;
  offset: any;
  assessmentSearchForm: any = FormGroup;

    isSaving: boolean = false;
    isEmpty: boolean = false;
    isSearching: any;
    page: number = 0;
    num: number = 1;
    currentPage: number = 1;
    count: number = 0;
    pageSize: number = 10;
    details: any;
    showSearch: boolean;

  constructor(
      private apiService: ApiServiceService,
        private authService: AuthService,
  ) {

  }

  ngOnInit(): void {
    this.search();
  }

    toggleSearch() {
        this.showSearch = !this.showSearch;
    }
  search() {
    this.isLoading = true;
    this.isSearching = true;
    const offset = this.page * 5;
    this.num = this.page * 5;
    
    const url = "/assessments/audit?page=" + this.page + "&pageSize=" + this.pageSize;

    this.apiService.post(url, {}).subscribe(
        (response) => {
          this.isLoading = false;
          this.isSearching = false;
          this.data = response.content;
          this.count = Math.ceil(response?.totalElements);
          this.offset = response?.offset;
        },
        (error) => {
          this.isLoading = false;
          this.isSearching = false;
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
        },
    );
  }

  performSearch(event: number) {
      this.currentPage = event;
      this.page = event - 1;
      this.search();
  }
    hasAccess(permissions:string[]){
        return this.authService.hasAnyPermission(permissions)
    }
}
